import React from "react";
import { ButtonPrimary } from "../common/ButtonPrimary";
import { StandardButton } from "../common/StandardButton";
import { useDiscountUpdate } from "@/hooks/useDiscountUpdate";
import { PageType, Collection } from "@/types/coupon/discount";

interface SelectedCollectionsListProps {
  currentPage: PageType;
  collectionsList: Collection[];
  onRemove?: (id: string) => void;
  onEdit?: () => void;
}

const SelectedCollectionsList = ({
  currentPage,
  collectionsList = [],
  onRemove,
  onEdit,
}: SelectedCollectionsListProps) => {
  const handleUpdate = useDiscountUpdate();

  const removeCollection = (id: string) => {
    handleUpdate(currentPage, {
      applicable_collections: collectionsList.filter((c) => c.id !== id) as [],
    });
    if (onRemove) {
      onRemove(id);
    }
  };

  return (
    <div className="space-y-3">
      {collectionsList.map(({ id, title, image }) => (
        <div
          key={id}
          className="bg-background border border-border rounded-xl overflow-hidden hover:border-primary/30 transition-all"
        >
          <div className="flex items-center justify-between p-4">
            <div className="flex items-center gap-4 flex-1 min-w-0">
              {image && (
                <div className="shrink-0 w-14 h-14 rounded-lg overflow-hidden bg-muted">
                  <img
                    src={image}
                    alt={title}
                    className="w-full h-full object-cover"
                  />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="text-[15px] font-semibold text-foreground truncate">{title}</p>
              </div>
            </div>
            <div className="flex items-center gap-2 shrink-0">
              <ButtonPrimary
                onClick={onEdit}
              >
                Edit
              </ButtonPrimary>
              <StandardButton
                onClick={() => removeCollection(id)}
                variant="destructive"
              >
                Remove
              </StandardButton>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SelectedCollectionsList;
